import React from 'react';
import { Box, Heading, Image, Paragraph } from '@zillow/constellation-10';
import type { StaticImageData } from 'next/image';

interface ValuePropProps {
  title: string;
  description: string;
  imageData: StaticImageData;
  imageAlt: string;
}

export function ValueProp({ title, description, imageData, imageAlt }: ValuePropProps) {
  return (
    <Box
      className="ztss-value-prop"
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        width: { base: '306px', md: '400px' },
      }}
    >
      <Image alt={imageAlt} {...imageData} width={150} height={150} loading="lazy" />

      <Heading
        level={3}
        textStyle="responsive.heading-sm"
        css={{
          marginTop: 'lg',
          marginBottom: 'sm',
        }}
      >
        {title}
      </Heading>

      <Paragraph textStyle="body-sm" css={{ color: 'text.neutral' }}>
        {description}
      </Paragraph>
    </Box>
  );
}
